import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import { Helmet } from 'react-helmet'
import Item from './Item'
import index from '../Header/index'

export default class FAQ extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired
      })
    ),
  }



  state = {
    active: null
  }

  render() {
    const { items, heading } = this.props
    const { active } = this.state

    return (
      <Wrapper>
        <Helmet>
          <script type="application/ld+json">
            {`           {
              "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
      ${items.map((item, index) => (
              `{
          "@type": "Question",
          "name": "${item.title}",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "${item.text}"
          }
        }`
            ))}
]}

    `}
          </script>
        </Helmet >
        <Title>
          {heading}
        </Title>
        <HeroWrapper fluid>
          <Row>
            <Col>
              <AccordionWrapper>
                {items.map((item, index) => (
                  <Item
                    {...item}
                    index={index}
                    key={index}
                    active={active === index}
                    onClick={() => this.setState({
                      active: index === active ? null : index
                    })}
                  />
                ))}
              </AccordionWrapper>
            </Col>
          </Row>
        </HeroWrapper>
      </Wrapper >
    );
  }
}

// Styles
const Wrapper = styled.section`

  
`
const HeroWrapper = styled(Container)`
margin-bottom: 65px;
padding: 0 0px;
${media.lg`
padding: 0 20%;
`}
`

const AccordionWrapper = styled.div`
  
`

const Title = styled.h2`
padding: 0 20px;
${media.lg`
padding: 0 20%;
`}
`


// WEBPACK FOOTER //
// ./src/ui/components/modules/FAQ/index.js